export class Gender {
  static List: any[] = [
    { id: 2, name: 'Femme' },
    { id: 1, name: 'Homme' },
  ];
}
